import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-152" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-153" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-154" data-mp="3fyvxs9ef7bak">
          Cosa dicono le insegnanti di danza
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-155" data-mp="36zimdb6qkcn7">
          <span aria-hidden="true" data-id="element-156" data-mp="36wmpzrajdw0v">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +1.500
          insegnanti di danza
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-3" data-id="element-157" data-mp="2x0tg6fo7cgms">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-158" data-mp="2s28cg69qretl">
              <div className="text-sm text-amber-500" aria-label="5 stelle su 5" data-id="element-159" data-mp="v8wtc9wl3kcp">
                <span aria-hidden="true" data-id="element-160" data-mp="q8ivfkop5qse">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-161" data-mp="h4n3qbjitzax">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-162" data-mp="78trkt9ps7to">
                <p className="text-xs font-bold text-ink" data-id="element-163" data-mp="7a4zn5a701ql">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-164" data-mp="c7df2y3yhro5">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-165" data-mp="14v9ck51cnnlz">
          Testimonianze illustrative mostrate a scopo dimostrativo.
        </p>
      </div>
    </section>;
}